import React from 'react'
import { observer } from 'mobx-react'
import * as linkConst from '../../constants/link_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const ContractTimeRestrictions = ({ store }) => {
  if (!store.hasRight(linkConst.LINK_CONTRACT_TIME_RESTRICTIONS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
      )
      return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
    },
    (attr, row) => (<DateField attr={attr} val={row[attr]} />)
  ]

  const filters = {
    id_like: {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    user_like: {
      title: 'User',
      component: (props) => (<TextInput {...props} />)
    },
    date: {
      title: 'Date',
      component: (props) => (<DateInput placeholderText='Select date' hideControlLabel asFilter {...props} />)
    }
  }

  return (<ListView
    store={store.cv}
    helper={store.helpFor(linkConst.LINK_CONTRACT_TIME_RESTRICTIONS)}
    fields={fields}
    filters={() => Filters(store, filters)}
    onAddClicked={store.addClicked.bind(store)}
    selectable={false} />
  )
}
export default observer(ContractTimeRestrictions)
